export const CANT_BE_EDITED_MSG = {
  inReferencingCategory:
    "Vous ne pouvez pas modifier un produit issu du référencement d'une réception.",
  disabledCompany:
    "Vous ne pouvez pas modifier un produit d'une entreprise désactivée.",
  disabledProduct: "Vous ne pouvez pas modifier un produit inactif.",
};
